import type { IconData } from '@stacksjs/iconify-core'

export const sr1x1: IconData = {
  "body": "<path fill=\"#377e3f\" d=\"M0 0h512v512H0z\"/><path fill=\"#fff\" d=\"M0 102.4h512v307.2H0z\"/><path fill=\"#b40a2d\" d=\"M0 153.6h512v204.8H0z\"/><path fill=\"#ecc81d\" d=\"m255.9 163.4l60.2 185.2l-157.6-114.5h194.8L195.7 348.6z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default sr1x1
